export const COUNT = 'Count';
export const PERCENTAGE = 'Percentage';
export const PCT = 'Pct';
export const BPS = 'bps';
export const LESS_THAN_NUMBER: any = 0.001;
